import { Story } from "~types/types";

export default function isPaywalled(story: Story) {
    return Boolean(
        story.archived || story.premium || story.metadata?.isMetered
    );
}
